import { axios } from '@/services/axios';

export const deleteTRSCluster = (clusterId) => {
    const endpoint = `/TRSCluster/${clusterId}`;
    const res = axios.delete(endpoint);
    return res;
};
